export default __webpack_public_path__ + "static/media/share_icon.ab5a8d51.svg";